import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class GameOverScene implements Scene {
  readonly id = "gameover" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.hideHud();
  }
  exit(): void {}
}
